<template>
  <back-section :menu="nama" />
  <ListDataApprove />
</template>
<script>
import ListDataApprove from "@/components/Approval/ListDataEoApprove.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      nama: "List Pegawai EO",
    };
  },
  components: { BackSection, ListDataApprove },
};
</script>
